import useSubmitBorrowerProfile from '../../hooks/complete_profile/useSubmitBorrowerProfile';
import Notify from '../Common/Notify';
import Wizard, { WizardContext, WizardPage } from '../Common/Wizard';
import BorrowerAddress from './BorrowerAddress';
import BorrowerBusiness from './BorrowerBusinesss';
import BorrowerBvnNin from './BorrowerBvnNin';
import BorrowerDocumentsProve from './BorrowerDocumentsProve';
import BorrowerEmployer from './BorrowerEmployer';
import BorrowerEmployment from './BorrowerEmployment';
import BorrowerLinkedin from './BorrowerLinkedin';
import BorrowerOccupation from './BorrowerOccupation';

const CreateBorrowerProfile = () => {
  const { onSubmit, error, submitting } = useSubmitBorrowerProfile();

  return (
    <div>
      <h1 className='fw-700 h0 mb-10'>Let's Know More About You</h1>
      {error && <Notify type='danger' message={error} />}
      <Wizard onSubmit={onSubmit} submitting={submitting}>
        <WizardPage>
          <BorrowerAddress />
        </WizardPage>
        <WizardPage>
          <BorrowerOccupation />
        </WizardPage>
        <WizardPage>
          <BorrowerEmployment />
        </WizardPage>
        <WizardPage>
          <WizardContext.Consumer>{(v) => (v.employment_status === 'self' ? <BorrowerBusiness /> : <BorrowerEmployer />)}</WizardContext.Consumer>
        </WizardPage>
        <WizardPage>
          <BorrowerLinkedin />
        </WizardPage>
        <WizardPage>
          <BorrowerBvnNin />
        </WizardPage>
        <WizardPage>
          <BorrowerDocumentsProve />
        </WizardPage>
      </Wizard>
    </div>
  );
};

export default CreateBorrowerProfile;
